<template>
  <section>
    <base-section-title class="text-center py-5">#{{$t('projects.title')}}'</base-section-title>
    <base-loading v-if="loading"/>
    <div v-else>
      <base-filter-group @filterChanged="changeFilter" :name="'categoryName'">
        <base-filter-item v-for="category in getProjectCategories"
          :key="'category_'+category"
          :value="category" />
      </base-filter-group>
      <div class="pb-5 grid gap-x-1 gap-y-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <base-project-card @click.native="openModal(project)" v-for="project in getFilteredProjects(filter)"
                           :project="project" :key="'project_'+project.id" />
      </div>
      <transition name="slide-up">
        <base-project-modal @onCloseModal="closeModal" :is-fullscreen="true" :project="selectedProject" v-if="showModal" />
      </transition>
    </div>
  </section>
</template>

<script>
import BaseProjectModal from '../../base/modals/BaseProjectModal'
import BaseProjectCard from '../../base/project/BaseProjectCard'
import BaseSectionTitle from '../../base/BaseSectionTitle'
import store from '../../../store'
import { mapGetters } from 'vuex'
import BaseFilterGroup from '../../base/filters/BaseFilterGroup'
import BaseFilterItem from '../../base/filters/BaseFilterItem'
import BaseLoading from '../../base/BaseLoading'
import projectsFilter from '../../../util/data-filters/projects-filter'

export default {
  name: 'ProjectsSection',
  components: { BaseLoading, BaseFilterItem, BaseFilterGroup, BaseProjectModal, BaseProjectCard, BaseSectionTitle },
  data () {
    return {
      showModal: false,
      selectedProject: null,
      loading: true,
      filter: projectsFilter
    }
  },
  methods: {
    openModal (project) {
      this.selectedProject = project
      this.showModal = true
    },
    closeModal () {
      this.selectedProject = null
      this.showModal = false
    },
    fetchData () {
      store.dispatch('projects/getProjects',
        { language: this.$i18n.locale })
        .then(() => {
          this.loading = false
        })
    },
    changeFilter (prop, value) {
      this.filter[prop] = value
    }
  },
  computed: {
    ...mapGetters('projects', ['getAllProjects', 'getFilteredProjects', 'getProjectCategories'])
  },
  watch: {
    '$i18n.locale': {
      handler () {
        this.loading = true
        store.dispatch('projects/resetState').then(() => {
          this.fetchData()
        })
      }
    }
  },
  mounted () {
    if (this.getAllProjects.length === 0) this.fetchData()
    else this.loading = false
  }
}
</script>

<style scoped>

</style>
